import { render, staticRenderFns } from "./UserSearchResultItem.vue?vue&type=template&id=6fa78024&scoped=true&"
import script from "./UserSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./UserSearchResultItem.vue?vue&type=script&lang=js&"
import style0 from "./UserSearchResultItem.vue?vue&type=style&index=0&id=6fa78024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa78024",
  null
  
)

export default component.exports